import Dialog from '@/components/Dialog';
import { type Level } from '@/lib/types';
import { IconButton } from '@mui/material';
import styled from '@emotion/styled';
import { Close as CloseIcon } from '@mui/icons-material';

const StyledDialogTitle = styled(Dialog.Title)({
  display: 'flex',
  alignItems: 'center',
  '> span': {
    marginRight: 12,
    flex: 1,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  '.MuiIconButton-root': {
    marginLeft: 'auto',
    flexShrink: 0,
  },
});

type AttachmentDialogTitleProps = {
  level: Level;
  onCloseDialog: () => void;
};

const AttachmentDialogTitle = ({
  level,
  onCloseDialog,
}: AttachmentDialogTitleProps) => (
  <StyledDialogTitle>
    <span>{level.title?.trim() || level.description}</span>
    <IconButton onClick={onCloseDialog}>
      <CloseIcon />
    </IconButton>
  </StyledDialogTitle>
);

export default AttachmentDialogTitle;
